// extracted by mini-css-extract-plugin
export default {"w-full":"TopCountries_w-full__laa62","item":"TopCountries_item__22cMT","flag":"TopCountries_flag__RLWo5","price":"TopCountries_price__DXJz0"};